import * as CpdActions from './cpd';
import * as PartWatchingActions from './partWatching';
import * as SalesActions from './sales';

const Actions = {
  ...CpdActions,
  ...PartWatchingActions,
  ...SalesActions,
};

export default Actions;
